import React from "react";
import { ScaleAnswerFormat } from "../../../../types/Survey";
import { createHelpers } from "./ScaleHelper";

export interface ScaleScreenReaderProps {
    value: string;
    minimumValue: number;
    maximumValue: number;
    range: number;
    step: number;
    answerFormat: ScaleAnswerFormat;
    inputIdForLabel: string;
    onChange: (value: string) => void;
}

export default function ScaleScreenReader({
    value,
    minimumValue,
    maximumValue,
    range,
    answerFormat,
    inputIdForLabel,
    step,
    onChange }: ScaleScreenReaderProps) {

    const { formatValue } = createHelpers(answerFormat);

    const markers: number[] = [];
    if (answerFormat.type == "ScaleAnswerFormat") {
        for (var i = step; i < range; i += step) {
            let markerValue = i
            markers.push(markerValue);
        }
    }

    return (
        <div className="sr-only">

            <div className="selected-value-display">
                {formatValue(value)}
            </div>
            <div className={answerFormat.vertical ? "scale-vertical" : "scale-horizontal"}>
                <div className="value min-value">
                    {formatValue(minimumValue.toString())}
                </div>
                <input type="range"
                    value={value}
                    onChange={(e) => { onChange(e.target.value) }}
                    id={inputIdForLabel}
                    role="slider"
                    min={minimumValue}
                    max={maximumValue}
                    aria-valuemin={minimumValue}
                    aria-valuemax={maximumValue}
                    aria-valuenow={+value}
                    step={step}
                    list="markers"
                    className={answerFormat.vertical ? "vertical" : "horizontal"}
                    style={answerFormat.vertical ? { writingMode: "vertical-lr", direction: "rtl" } : {}}
                />
                <div className="value max-value">
                    {formatValue(maximumValue.toString())}
                </div>
                <datalist id="markers">
                    <option value={minimumValue}></option>
                    {markers.map(marker =>
                        <option value={marker} key={marker}></option>
                    )}
                    <option value={maximumValue}></option>
                </datalist>
                <div className="descriptions">
                    <div className="description min-value-description">{answerFormat.minimumValueDescription}</div>
                    <div className="description max-value-description">{answerFormat.maximumValueDescription}</div>
                    <div style={{ clear: "both" }}></div>
                </div>
            </div >
        </div>
    )
}